// The sales list (public.dashboard_unsold_territory): every website with no active client, and the leads it brings
// in. Counts only; never a lead's name or contact details.
import {csvCell} from './inventory-export';

export type SiteStatus='never_sold'|'client_left'|'client_paused';
export interface UnsoldSite {
 property_id:number;website:string;city:string|null;state:string|null;live_status:string|null;
 status:SiteStatus;last_client:string|null;left_on:string|null;
 leads:number;leads_30d:number;leads_7d:number;calls:number;forms:number;spam:number;last_lead_at:string|null;
 services:Array<{service:string;leads:number}>;
}
export interface SalesListData {
 days:number;generated_at:string;
 totals:{sites:number;sites_with_leads:number;never_sold:number;client_left:number;client_paused:number;leads:number;leads_30d:number;leads_7d:number};
 sites:UnsoldSite[];
}

export const STATUS_LABELS:Record<SiteStatus,string>={never_sold:'Never sold',client_left:'Client left',client_paused:'Client paused'};

const day=(iso:string)=>new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',year:'numeric',timeZone:'UTC'}).format(new Date(iso));

/** Why a website has no client, in words: "Never sold", "Acme left on Sep 19, 2026", "Acme is paused". */
export function whyNoClient(site:Pick<UnsoldSite,'status'|'last_client'|'left_on'>):string{
 if(site.status==='client_left')return `${site.last_client??'The client'} left${site.left_on?` on ${day(site.left_on)}`:''}`;
 if(site.status==='client_paused')return `${site.last_client??'The client'} is paused`;
 return STATUS_LABELS.never_sold;
}

/** "Tulsa, OK", or whichever part is known. */
export const place=(site:Pick<UnsoldSite,'city'|'state'>)=>[site.city,site.state].filter(Boolean).join(', ');

/** "Drain cleaning (3), Sewer repair (2)". */
export const servicesText=(site:Pick<UnsoldSite,'services'>)=>site.services.map(s=>`${s.service} (${s.leads})`).join(', ');

/** The list as a spreadsheet, one row per website, in the order shown. */
export function salesCsv(sites:readonly UnsoldSite[],days:number):string{
 const header=['Website','City','State','Why no client','Last client','Left on',`Leads (${days} days)`,'Last 30 days','Last 7 days','Calls','Forms','Spam','Last lead','Top services'];
 const rows=sites.map(s=>[s.website,s.city,s.state,whyNoClient(s),s.last_client,s.left_on?.slice(0,10),s.leads,s.leads_30d,s.leads_7d,s.calls,s.forms,s.spam,s.last_lead_at?.slice(0,10),servicesText(s)]);
 return [header,...rows].map(r=>r.map(csvCell).join(',')).join('\r\n');
}
